import { createCRUDHook } from './createCRUDHook';
import { BrushDto } from 'utils/models';
import { TBL_BRUSH_TYPE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<BrushDto>({
  entityName: 'BrushType',
  endpoint: TBL_BRUSH_TYPE,
});

export const BrushTypeContext = Context;
export const useBrushTypeManager = useManager;
export const useBrushType = useConsumer;
